import React, { useContext, useEffect, useState } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import { AuthContext } from "../../context/Auth/AuthContext";

// Barra de progresso padrao das importacoes (listas, planilha de contatos e
// agenda). Escuta sozinha o canal escopado recebido em `canal` — os eventos
// seguem o contrato import-start {total} -> import-progress {processados,
// total, ...contadores} -> import-finish/import-error — e some ao concluir.
// Os contadores variam por fluxo (criados/ignorados/invalidos na planilha,
// criados/atualizados/falhas na agenda); so os presentes sao exibidos.
//
// `onFinish`/`onError`/`onCancel` deixam a tela reagir (ex.: mostrar painel de
// resultado) sem precisar assinar o canal de novo. `onCancelar` (a acao, nao o
// evento) exibe um botao "Cancelar" na barra — so os fluxos que suportam
// cancelamento no backend devem passa-lo.

const ROTULOS = [
  ["criados", "novo(s)"],
  ["atualizados", "atualizado(s)"],
  ["ignorados", "ja existia(m)"],
  ["invalidos", "invalido(s)"],
  ["falhas", "falha(s)"]
];

const descreveContadores = estado =>
  ROTULOS.filter(([campo]) => estado[campo] !== undefined)
    .map(([campo, rotulo]) => `${estado[campo] || 0} ${rotulo}`)
    .join(" · ");

const ImportacaoProgresso = ({ canal, onFinish, onError, onCancel, onCancelar }) => {
  const { socket } = useContext(AuthContext);
  const [estado, setEstado] = useState(null);
  const [cancelando, setCancelando] = useState(false);

  useEffect(() => {
    if (!socket || !canal) return undefined;

    const onEvento = data => {
      if (data.action === "import-start") {
        setEstado({ processados: 0, total: data.total });
        setCancelando(false);
      }

      if (data.action === "import-progress") {
        setEstado(data);
      }

      if (data.action === "import-finish") {
        setEstado(null);
        if (onFinish) onFinish(data);
      }

      if (data.action === "import-error") {
        setEstado(null);
        if (onError) onError(data);
      }

      if (data.action === "import-cancel") {
        setEstado(null);
        setCancelando(false);
        if (onCancel) onCancel(data);
      }
    };

    socket.on(canal, onEvento);
    return () => socket.off(canal, onEvento);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, canal]);

  if (!estado) return null;

  const contadores = descreveContadores(estado);

  return (
    <div style={{ padding: "12px 16px" }} aria-live="polite">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 6
        }}
      >
        <Typography variant="body2">
          {cancelando
            ? "Cancelando a importacao..."
            : estado.total > 0
              ? `Importando contatos: ${estado.processados} de ${estado.total}`
              : "Preparando a importacao..."}
        </Typography>
        {onCancelar && (
          <Button
            size="small"
            color="secondary"
            disabled={cancelando}
            onClick={() => {
              setCancelando(true);
              onCancelar();
            }}
          >
            Cancelar
          </Button>
        )}
      </div>
      <LinearProgress
        variant={estado.total > 0 ? "determinate" : "indeterminate"}
        value={estado.total > 0 ? (estado.processados / estado.total) * 100 : 0}
      />
      {contadores && (
        <Typography
          variant="caption"
          color="textSecondary"
          style={{ display: "block", marginTop: 6 }}
        >
          {contadores}
        </Typography>
      )}
    </div>
  );
};

export default ImportacaoProgresso;
